import { Helmet } from 'react-helmet-async'

const Viewport = ({
  content = ['width=device-width', 'initial-scale=1', 'viewport-fit=cover']
}) => {
  const value = content.join(', ')
  return (
    <Helmet>
      <meta name="viewport" content={value} />
    </Helmet>
  )
}

export default Viewport
